import React from 'react';
import ShopHeaderRight from './ShopHeaderRight';

// Helper to generate section id from category label
function getSectionIdFromLabel(label) {
  return label
    .replace(/^\W+/, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
}

const ShopHeaderRow = ({ shop, SHOP_TYPE_CATEGORIES }) => (
  <div className="header-row">
    {/* Left: Business name, subtitle, shopType badges */}
    <div className="header-left">
      {/* Row 1: Business name + status icon */}
      <div className="shop-name-status-row">
        <h1 className="shop-name">{shop.shopName}</h1>
        {(() => {
          const lastActive = new Date(shop.lastActivity);
          const now = new Date();
          const diff = (now - lastActive) / (1000 * 60 * 60 * 24);
          if (diff <= 7) {
            return <i className="pi pi-verified active-status-icon" title="Verified Active" style={{ color: 'var(--primary-600)', fontSize: '1.7rem', marginLeft: '0.7rem', verticalAlign: 'middle' }} />;
          }
          return null;
        })()}
      </div>
      {/* Row 2: Shop types as chips */}
      <div className="shoptype-chips-row">
        {SHOP_TYPE_CATEGORIES.filter(cat =>
          cat.items.some(item => shop.shopType.includes(item.value))
        ).map(cat => (
          <div
            className="shoptype-chip"
            key={cat.label}
            title={cat.label.replace(/^\W+\s*/, '')}
            onClick={() => {
              const sectionId = getSectionIdFromLabel(cat.label);
              const section = document.getElementById(sectionId);
              if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            <span className="shoptype-chip-icon">{cat.label.match(/^\W+/) ? cat.label.match(/^\W+/)[0] : ''}</span>
            <span className="shoptype-chip-label">{cat.label.replace(/^\W+\s*/, '')}</span>
          </div>
        ))}
      </div>
    </div>
    {/* Right: Shop images carousel/card */}
    <ShopHeaderRight storeImages={shop.storeImages} shopName={shop.shopName} />
  </div>
);

export default ShopHeaderRow;
